import { FileVerifiedIcon } from "@hugeicons-pro/core-stroke-rounded";
import { Section } from "views/applications-id-report/components/Section";
import { Row } from "views/applications-id-report/components/Row";
import { SectionIcon } from "../components/SectionIcon";
import { PurchaseApplicationReport } from "../types";
import { formatDate, formatLabel } from "../utils";

export const ApplicationSlice = ({
  report
}: {
  report: PurchaseApplicationReport;
}) => (
  <Section
    sectionTitle="Application"
    icon={<SectionIcon icon={FileVerifiedIcon} />}
  >
    <div className="space-y-2">
      <Row title="Community" value={report.communityName} />
      <Row title="Unit" value={report.unitName} />
      <Row
        title="Usage type"
        value={formatLabel(report.purchaseInfo.propertyUsageType)}
      />
      <Row title="Status" value={formatLabel(report.boomFinanceStatus)} />
      <Row title="Submitted" value={formatDate(report.submittedAt)} />
      <Row title="Last updated" value={formatDate(report.lastUpdatedAt)} />
      <Row title="Application ID" value={report.boomFinanceApplicationId} />
    </div>
  </Section>
);
